module.exports = __webpack_public_path__ + "static/dealerlogo-c436e2df2a5ab1ca44d1eabee5f4784b.png";